import React, { useState, useEffect, useRef } from 'react';
import '../style.css';

const API = 'https://culturlingua.com/blog_api.php';

const CATEGORY_COLORS = {
  'Inglés': '#3b6fe0', 'Consejos': '#059669', 'Certificaciones': '#7c3aed',
  'Para padres': '#ea580c', 'Empresas': '#0891b2', 'Español': '#dc2626', 'General': '#6b7280'
};

// Suggested emojis grouped by theme — for the picker
const EMOJI_GROUPS = [
  { label: 'Idiomas', emojis: ['🌍','🗣️','💬','🗺️','🌐','📢','🔤','🔡','✏️','🖊️'] },
  { label: 'Aprendizaje', emojis: ['📚','📖','🎓','🏫','🧠','💡','🔬','📝','📋','✅'] },
  { label: 'Inglés', emojis: ['🇬🇧','🇺🇸','🎧','🎤','🎙️','📻','🗞️','📰','🧩','🎯'] },
  { label: 'Español', emojis: ['🇲🇽','🇪🇸','🌮','💃','🎸','🌺','☀️','🏖️','🎭','🌻'] },
  { label: 'Comunicación', emojis: ['💌','📧','📞','🤝','👥','🧑‍💼','💼','🏆','⭐','🎖️'] },
  { label: 'Tecnología', emojis: ['💻','📱','🖥️','⌨️','🖱️','🎮','🤖','📡','🔧','⚙️'] },
  { label: 'Viajes', emojis: ['✈️','🧳','🗼','🏛️','🗽','🏯','⛺','🚢','🌄','🌇'] },
  { label: 'Varios', emojis: ['🔥','💪','🚀','🌟','💎','🎁','🎉','🎊','🌈','❤️'] },
];

function getToken() { return localStorage.getItem('blog_token'); }
function authHeaders() { return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getToken() }; }

// ── EMOJI PICKER ───────────────────────────────────────────────
function EmojiPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const allEmojis = EMOJI_GROUPS.flatMap(g => g.emojis);
  const filtered  = filter
    ? allEmojis.filter(e => e.includes(filter))
    : null;

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button
          type="button"
          onClick={() => setOpen(o => !o)}
          style={{
            width: '56px', height: '56px', borderRadius: '12px',
            border: '1.5px solid #e5e7eb', background: 'white',
            fontSize: '28px', cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            transition: 'border-color .2s',
            ...(open ? { borderColor: '#1a1744' } : {}),
          }}
        >
          {value || '＋'}
        </button>
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            style={{ background: 'none', border: 'none', color: '#ccc', cursor: 'pointer', fontSize: '0.8rem', padding: '4px' }}
          >
            Quitar
          </button>
        )}
        <span style={{ color: '#999', fontSize: '0.8rem' }}>
          {value ? 'Emoji seleccionado' : 'Sin emoji — se usará color + iniciales'}
        </span>
      </div>

      {open && (
        <div style={{
          position: 'absolute', top: '64px', left: 0, zIndex: 100,
          background: 'white', borderRadius: '16px', boxShadow: '0 8px 40px rgba(0,0,0,0.15)',
          border: '1px solid #e5e7eb', width: '360px', padding: '16px',
        }}>
          <input
            autoFocus
            placeholder="Buscar emoji…"
            value={filter}
            onChange={e => setFilter(e.target.value)}
            style={{
              width: '100%', padding: '8px 12px', borderRadius: '8px',
              border: '1.5px solid #e5e7eb', fontFamily: 'DM Sans, sans-serif',
              fontSize: '0.875rem', outline: 'none', boxSizing: 'border-box',
              marginBottom: '12px',
            }}
          />
          <div style={{ maxHeight: '280px', overflowY: 'auto' }}>
            {(filtered ? [{ label: 'Resultados', emojis: filtered }] : EMOJI_GROUPS).map(group => (
              <div key={group.label} style={{ marginBottom: '12px' }}>
                <div style={{ fontSize: '0.68rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.1em', color: '#bbb', marginBottom: '6px' }}>
                  {group.label}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {group.emojis.map(e => (
                    <button
                      key={e}
                      type="button"
                      onClick={() => { onChange(e); setOpen(false); setFilter(''); }}
                      style={{
                        width: '36px', height: '36px', border: 'none',
                        borderRadius: '8px', background: value === e ? '#f0f0ff' : 'transparent',
                        fontSize: '20px', cursor: 'pointer', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        transition: 'background .15s',
                      }}
                      onMouseEnter={e2 => e2.currentTarget.style.background = '#f5f5f5'}
                      onMouseLeave={e2 => e2.currentTarget.style.background = value === e ? '#f0f0ff' : 'transparent'}
                    >
                      {e}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ── LOGIN ──────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [err,  setErr]  = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true); setErr('');
    const r = await fetch(`${API}?action=login`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user, pass })
    });
    const d = await r.json();
    setLoading(false);
    if (d.token) { localStorage.setItem('blog_token', d.token); onLogin(); }
    else setErr('Usuario o contraseña incorrectos');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'white', borderRadius: '20px', padding: '48px', width: '360px', boxShadow: '0 24px 64px rgba(0,0,0,0.3)' }}>
        <h2 style={{ fontFamily: 'Fraunces, serif', color: 'var(--navy)', marginBottom: '8px', fontSize: '1.6rem' }}>Blog Admin</h2>
        <p style={{ color: '#999', fontSize: '0.875rem', marginBottom: '32px' }}>Culturlingua</p>
        <input placeholder="Usuario" value={user} onChange={e => setUser(e.target.value)}
          style={inputStyle} />
        <input type="password" placeholder="Contraseña" value={pass} onChange={e => setPass(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && submit()} style={{ ...inputStyle, marginTop: '12px' }} />
        {err && <p style={{ color: '#dc2626', fontSize: '0.82rem', marginTop: '8px' }}>{err}</p>}
        <button onClick={submit} disabled={loading}
          style={{ width: '100%', padding: '13px', marginTop: '20px', borderRadius: '10px', background: 'var(--navy)', color: 'white', border: 'none', fontWeight: 700, fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', cursor: 'pointer' }}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%', padding: '12px 14px', borderRadius: '10px',
  border: '1.5px solid #e5e7eb', fontFamily: 'DM Sans, sans-serif',
  fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box', display: 'block'
};
const labelStyle = {
  display: 'block', fontFamily: 'DM Sans, sans-serif', fontWeight: 600,
  color: 'var(--navy)', fontSize: '0.85rem', marginBottom: '6px'
};

// ── EDITOR ────────────────────────────────────────────────────
function Editor({ post, onSave, onCancel }) {
  const isNew = !post?.id;
  const [form, setForm] = useState({
    slug: post?.slug || '', title: post?.title || '', excerpt: post?.excerpt || '',
    content: post?.content || '', category: post?.category || 'Consejos',
    category_color: post?.category_color || '#3b6fe0',
    icon: post?.icon || '',
    read_time: post?.read_time || '4 min', published: post?.published ?? 1
  });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const autoSlug = (title) => title.toLowerCase()
    .replace(/[áàä]/g, 'a').replace(/[éèë]/g, 'e').replace(/[íìï]/g, 'i')
    .replace(/[óòö]/g, 'o').replace(/[úùü]/g, 'u').replace(/ñ/g, 'n')
    .replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-').slice(0, 80);

  const save = async () => {
    setSaving(true); setErr('');
    const url = isNew ? `${API}?action=create` : `${API}?action=update&id=${post.id}`;
    const method = isNew ? 'POST' : 'PUT';
    const r = await fetch(url, { method, headers: authHeaders(), body: JSON.stringify(form) });
    const d = await r.json();
    setSaving(false);
    if (d.success) onSave();
    else setErr(d.error || 'Error al guardar');
  };

  // Live card preview
  const previewColor = form.category_color || '#3b6fe0';
  const previewBg    = previewColor + '18';

  return (
    <div style={{ maxWidth: '920px', margin: '0 auto', padding: '32px 24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '28px' }}>
        <h2 style={{ fontFamily: 'Fraunces, serif', color: 'var(--navy)', fontSize: '1.5rem' }}>
          {isNew ? 'Nuevo artículo' : 'Editar artículo'}
        </h2>
        <button onClick={onCancel} style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '0.9rem' }}>
          ← Volver
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 280px', gap: '32px', alignItems: 'start' }}>
        {/* Main form */}
        <div style={{ display: 'grid', gap: '16px' }}>
          <div>
            <label style={labelStyle}>Título</label>
            <input value={form.title} style={inputStyle}
              onChange={e => { set('title', e.target.value); if (isNew) set('slug', autoSlug(e.target.value)); }} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
              <label style={labelStyle}>Slug (URL)</label>
              <input value={form.slug} style={inputStyle} onChange={e => set('slug', e.target.value)} />
              <p style={{ color: '#999', fontSize: '0.75rem', marginTop: '4px' }}>
                /blog/<strong>{form.slug || 'tu-slug-aqui'}</strong>
              </p>
            </div>
            <div>
              <label style={labelStyle}>Tiempo de lectura</label>
              <input value={form.read_time} style={inputStyle} onChange={e => set('read_time', e.target.value)} placeholder="4 min" />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
              <label style={labelStyle}>Categoría</label>
              <select value={form.category} style={inputStyle}
                onChange={e => { set('category', e.target.value); set('category_color', CATEGORY_COLORS[e.target.value] || '#3b6fe0'); }}>
                {Object.keys(CATEGORY_COLORS).map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Color categoría</label>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <input type="color" value={form.category_color} onChange={e => set('category_color', e.target.value)}
                  style={{ width: '48px', height: '40px', border: '1.5px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', padding: '2px' }} />
                <input value={form.category_color} style={{ ...inputStyle, flex: 1 }} onChange={e => set('category_color', e.target.value)} />
              </div>
            </div>
          </div>

          {/* Emoji picker — new */}
          <div>
            <label style={labelStyle}>Icono del artículo</label>
            <EmojiPicker value={form.icon} onChange={v => set('icon', v)} />
          </div>

          <div>
            <label style={labelStyle}>Descripción corta (aparece en Google y en la lista)</label>
            <textarea value={form.excerpt} style={{ ...inputStyle, height: '80px', resize: 'vertical' }}
              onChange={e => set('excerpt', e.target.value)} />
            <p style={{ color: form.excerpt.length > 160 ? '#dc2626' : '#999', fontSize: '0.75rem', marginTop: '4px' }}>
              {form.excerpt.length}/160 caracteres
            </p>
          </div>

          <div>
            <label style={labelStyle}>Contenido HTML</label>
            <p style={{ color: '#999', fontSize: '0.75rem', marginBottom: '8px' }}>
              Usa etiquetas: &lt;h2&gt;, &lt;h3&gt;, &lt;p&gt;, &lt;ul&gt;&lt;li&gt;, &lt;ol&gt;&lt;li&gt;, &lt;strong&gt;, &lt;blockquote&gt;, &lt;a href=""&gt;
            </p>
            <textarea value={form.content} style={{ ...inputStyle, height: '400px', resize: 'vertical', fontFamily: 'monospace', fontSize: '0.82rem' }}
              onChange={e => set('content', e.target.value)} />
          </div>

          <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.published === 1}
                onChange={e => set('published', e.target.checked ? 1 : 0)}
                style={{ width: '16px', height: '16px' }} />
              <span style={{ fontFamily: 'DM Sans', fontWeight: 600, color: 'var(--navy)' }}>Publicado</span>
            </label>
            <span style={{ color: '#999', fontSize: '0.82rem' }}>
              {form.published ? 'Visible en el blog público' : 'Borrador — no visible aún'}
            </span>
          </div>

          {err && (
            <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '10px', padding: '12px 16px', color: '#dc2626', fontSize: '0.875rem' }}>
              {err}
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px', paddingTop: '8px' }}>
            <button onClick={save} disabled={saving}
              style={{ padding: '13px 32px', borderRadius: '10px', background: 'var(--navy)', color: 'white', border: 'none', fontWeight: 700, fontFamily: 'DM Sans, sans-serif', cursor: 'pointer', fontSize: '0.95rem' }}>
              {saving ? 'Guardando...' : (isNew ? 'Publicar artículo' : 'Guardar cambios')}
            </button>
            <button onClick={onCancel}
              style={{ padding: '13px 24px', borderRadius: '10px', background: '#f3f4f6', color: '#666', border: 'none', fontWeight: 600, fontFamily: 'DM Sans, sans-serif', cursor: 'pointer' }}>
              Cancelar
            </button>
          </div>
        </div>

        {/* Live card preview */}
        <div style={{ position: 'sticky', top: '100px' }}>
          <div style={{ fontSize: '0.68rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.1em', color: '#bbb', marginBottom: '12px' }}>
            Vista previa
          </div>
          <div style={{ background: 'white', borderRadius: '18px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(26,23,68,.10)' }}>
            {/* Card visual */}
            <div style={{
              height: '140px', background: `linear-gradient(135deg, ${previewColor}, ${previewColor}99)`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              position: 'relative', overflow: 'hidden',
            }}>
              {/* subtle pattern */}
              <div style={{ position:'absolute',inset:0, backgroundImage:`radial-gradient(circle, rgba(255,255,255,0.12) 1px, transparent 1px)`, backgroundSize:'20px 20px' }}/>
              {form.icon ? (
                <span style={{ fontSize: '52px', filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.2))', position: 'relative', zIndex: 2 }}>
                  {form.icon}
                </span>
              ) : (
                <span style={{ fontFamily: 'Fraunces, serif', fontSize: '3.5rem', fontWeight: 900, color: 'rgba(255,255,255,0.2)', position: 'relative', zIndex: 2 }}>
                  {(form.category || 'Ge').substring(0, 2).toUpperCase()}
                </span>
              )}
            </div>
            {/* Card body */}
            <div style={{ padding: '18px 20px 16px' }}>
              <span style={{ fontSize: '0.68rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.06em', padding: '3px 9px', borderRadius: '100px', background: previewBg, color: previewColor, marginBottom: '10px', display: 'inline-block' }}>
                {form.category || 'Categoría'}
              </span>
              <div style={{ fontFamily: 'Fraunces, serif', fontSize: '1rem', fontWeight: 800, color: '#1a1744', lineHeight: 1.3, marginBottom: '8px' }}>
                {form.title || 'Título del artículo'}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '12px', borderTop: '1px solid #f0ede8', fontSize: '0.76rem' }}>
                <span style={{ color: '#c0b8a8' }}>Hoy</span>
                <span style={{ color: '#3b6fe0', fontWeight: 700 }}>{form.read_time || '4 min'} →</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── MAIN ADMIN ─────────────────────────────────────────────────
export default function BlogAdmin() {
  const [authed,  setAuthed]  = useState(!!getToken());
  const [posts,   setPosts]   = useState([]);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadPosts = () => {
    setLoading(true);
    fetch(`${API}?action=admin_posts`, { headers: authHeaders() })
      .then(r => r.json()).then(d => { setPosts(Array.isArray(d) ? d : []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { if (authed) loadPosts(); }, [authed]);

  const editPost = async (id) => {
    const r = await fetch(`${API}?action=admin_post&id=${id}`, { headers: authHeaders() });
    const d = await r.json();
    setEditing(d);
  };

  const deletePost = async (id, title) => {
    if (!window.confirm(`¿Eliminar "${title}"? Esta acción no se puede deshacer.`)) return;
    await fetch(`${API}?action=delete&id=${id}`, { method: 'DELETE', headers: authHeaders() });
    loadPosts();
  };

  const togglePublished = async (post) => {
    await fetch(`${API}?action=update&id=${post.id}`, {
      method: 'PUT', headers: authHeaders(),
      body: JSON.stringify({ ...post, published: post.published ? 0 : 1 })
    });
    loadPosts();
  };

  const logout = () => { localStorage.removeItem('blog_token'); setAuthed(false); };

  if (!authed) return <LoginScreen onLogin={() => setAuthed(true)} />;

  if (editing !== null) return (
    <div style={{ background: 'var(--cream)', minHeight: '100vh' }}>
      <div style={{ background: 'white', borderBottom: '1px solid #e5e7eb', padding: '14px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontFamily: 'Fraunces, serif', fontWeight: 700, color: 'var(--navy)' }}>Blog Admin · Culturlingua</span>
        <button onClick={logout} style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '0.85rem' }}>Cerrar sesión</button>
      </div>
      <Editor post={editing} onSave={() => { setEditing(null); loadPosts(); }} onCancel={() => setEditing(null)} />
    </div>
  );

  return (
    <div style={{ background: 'var(--cream)', minHeight: '100vh' }}>
      <div style={{ background: 'white', borderBottom: '1px solid #e5e7eb', padding: '14px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontFamily: 'Fraunces, serif', fontWeight: 700, color: 'var(--navy)', fontSize: '1.1rem' }}>Blog Admin · Culturlingua</span>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <a href="/blog" target="_blank" style={{ color: '#999', fontSize: '0.85rem', textDecoration: 'none' }}>Ver blog público →</a>
          <button onClick={logout} style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '0.85rem' }}>Cerrar sesión</button>
        </div>
      </div>

      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '28px' }}>
          <div>
            <h1 style={{ fontFamily: 'Fraunces, serif', color: 'var(--navy)', fontSize: '1.8rem', marginBottom: '4px' }}>Artículos</h1>
            <p style={{ color: '#999', fontSize: '0.875rem' }}>{posts.length} artículo{posts.length !== 1 ? 's' : ''} en total</p>
          </div>
          <button onClick={() => setEditing({})}
            style={{ padding: '12px 24px', borderRadius: '10px', background: 'var(--navy)', color: 'white', border: 'none', fontWeight: 700, fontFamily: 'DM Sans, sans-serif', cursor: 'pointer', fontSize: '0.9rem' }}>
            + Nuevo artículo
          </button>
        </div>

        {loading && <p style={{ color: '#999', textAlign: 'center', padding: '40px' }}>Cargando...</p>}

        {!loading && posts.length === 0 && (
          <div style={{ textAlign: 'center', padding: '80px', background: 'white', borderRadius: '16px' }}>
            <p style={{ fontSize: '2.5rem' }}>📝</p>
            <h3 style={{ fontFamily: 'Fraunces, serif', color: 'var(--navy)', marginTop: '12px' }}>Sin artículos aún</h3>
            <p style={{ color: '#999', marginTop: '8px' }}>Haz clic en "+ Nuevo artículo" para empezar.</p>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {posts.map(post => (
            <div key={post.id} style={{ background: 'white', borderRadius: '14px', padding: '18px 24px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', gap: '16px' }}>
              {/* Color bar */}
              <div style={{ width: '4px', height: '48px', background: post.category_color || '#3b6fe0', borderRadius: '2px', flexShrink: 0 }} />
              {/* Emoji badge */}
              <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: (post.category_color || '#3b6fe0') + '15', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: post.icon ? '22px' : '14px', flexShrink: 0, color: post.category_color || '#3b6fe0', fontWeight: 800 }}>
                {post.icon || (post.category || 'G').substring(0, 2).toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
                  <span style={{ fontFamily: 'Fraunces, serif', fontWeight: 700, color: 'var(--navy)', fontSize: '1rem' }}>{post.title}</span>
                  <span style={{ fontSize: '0.7rem', padding: '2px 8px', borderRadius: '100px', fontWeight: 700, background: post.published ? '#d1fae5' : '#f3f4f6', color: post.published ? '#065f46' : '#6b7280' }}>
                    {post.published ? 'Publicado' : 'Borrador'}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <span style={{ color: '#999', fontSize: '0.78rem' }}>{post.category}</span>
                  <span style={{ color: '#ddd' }}>·</span>
                  <span style={{ color: '#999', fontSize: '0.78rem' }}>/blog/{post.slug}</span>
                  <span style={{ color: '#ddd' }}>·</span>
                  <span style={{ color: '#999', fontSize: '0.78rem' }}>{post.read_time}</span>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
                <button onClick={() => togglePublished(post)}
                  style={{ padding: '7px 14px', borderRadius: '8px', border: '1.5px solid #e5e7eb', background: 'white', color: '#666', fontFamily: 'DM Sans, sans-serif', fontSize: '0.8rem', cursor: 'pointer', fontWeight: 600 }}>
                  {post.published ? 'Despublicar' : 'Publicar'}
                </button>
                <button onClick={() => editPost(post.id)}
                  style={{ padding: '7px 16px', borderRadius: '8px', border: 'none', background: 'var(--navy)', color: 'white', fontFamily: 'DM Sans, sans-serif', fontSize: '0.8rem', cursor: 'pointer', fontWeight: 600 }}>
                  Editar
                </button>
                <button onClick={() => deletePost(post.id, post.title)}
                  style={{ padding: '7px 14px', borderRadius: '8px', border: '1.5px solid #fecaca', background: 'white', color: '#dc2626', fontFamily: 'DM Sans, sans-serif', fontSize: '0.8rem', cursor: 'pointer', fontWeight: 600 }}>
                  ✕
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}